import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

import { TOCItem } from './types';

const useStyles = makeStyles(() => ({
  nestedLinks: {
    paddingLeft: 10,
  },
  h2: {
    '& > a': {
      fontWeight: 400,
    },
  },
  h3: {
    '& > a': {
      fontWeight: 300,
    },
  },
  h4: {
    '& > a': {
      fontWeight: 300,
    },
  },
}));

type Props = {
  item: TOCItem;
};

export const Chapter = ({ item }: Props) => {
  const classes = useStyles();
  const { title, id, items } = item;

  return (
    <Fragment key={`${title}-${id}`}>
      <li key={`${title}-$${id}`} className={classes.h2}>
        <Link to={`#${id}`}>{title}</Link>
      </li>
      {items.length > 0 && (
        <ul className={classes.nestedLinks}>
          {items.map(({ title, id, items }) => (
            <Fragment key={`${title}-${id}`}>
              <li className={classes.h3}>
                <Link to={`#${id}`}>{title}</Link>
              </li>
              {items.length > 0 && (
                <ul>
                  {items.map(({ id, title }) => (
                    <li key={`${title}-${id}`} className={classes.h4}>
                      <Link to={`#${id}`}>{title}</Link>
                    </li>
                  ))}
                </ul>
              )}
            </Fragment>
          ))}
        </ul>
      )}
    </Fragment>
  );
};
